<!--  -->
<template>
  <div>
    <el-upload
      :class="showFile ? 'avatar-uploader' : 'upload-demo'"
      ref="upload"
      action=""
      :on-change="handleChange"
      :show-file-list="false"
      :auto-upload="false"
    >
      <i v-if="showFile" class="el-icon-plus avatar-uploader-icon"></i>
      <el-button v-else class="btn" :size="size" :type="type" :icon="icon">{{
        submitTxt
      }}</el-button>
    </el-upload>
  </div>
</template>

<script>
import axios from "axios";
import configs from "../configs"
export default {
  props: {
    submitTxt: "",
    size: "",
    type: "",
    icon: "",
    data: {},
    noSubmit: false,
    showFile: false,
    fileName: "",
  },
  data() {
    return {
      imageUrl: "",
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    handleChange(file) {
      if (this.noSubmit) {
        this.imageUrl = URL.createObjectURL(file.raw);
        console.log(this.imageUrl);
        this.$emit("getFile", { fileName: this.fileName, file: file.raw, url: this.imageUrl});
        return;
      }
      const formdata = new FormData();
      formdata.append("files", file.raw);
      formdata.append("token", this.data.token);
      formdata.append("action", this.data.action);
      this.submit(formdata);
    },
    submit(data) {
      axios({
        url: configs.baseURL+"excel/add",
        method: "post",
        data: data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 20000,
      })
        .then((res) => {
          if (res.data && res.data.status) {
            if (res.data.status.state == 1000) {
              this.$message.success(this.$configs.message.exportSucc);
              this.$emit("searchList");
            } else {
              this.$message.error(this.$configs.message.exportErr);
            }
          } else {
            this.$message.error(this.$configs.message.exportErr);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.btn {
  width: 110px;
  height: 40px;
  margin: 0 10px;
  padding: 0;
}
/deep/.avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 56px;
    line-height: 56px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 56px;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Upload.vue